<template functional>
  <div :class="props.headerClass" role="heading">
    <h2 style="font-size:18px;"><slot /></h2>
    <div class="muted--text" style="font-size: 12px;">
      <slot name="info" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "AppHeader",
  props: {
    headerClass: {
      type: String,
      default: "mb-4 mt-6"
    }
  }
});
</script>
